import React from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import orderStore from "../../stores/order";
import { observer } from "mobx-react";
import menuStore from "../../stores/menu";
import { getCurrency } from "../../helpers/ApiHelper";

export interface FooterProps {
    showBack?: boolean;
    skipRecommendations?: boolean;
    showDarkViewOrder?: boolean;
}

const Footer = ({showBack, skipRecommendations, showDarkViewOrder}: FooterProps) => {
    const [t] = useTranslation();
    const navigate = useNavigate();

    const goBack = () => {
        if (menuStore.returnToScanArticle) {
            navigate("/scanArticle");
            return;
        }

        if (skipRecommendations) {
            navigate("/menu");
            return;
        }

        if (menuStore.navigation.isAddedToOrder)
            navigate("/recommendations");
        else
            navigate("/menu");
    }

    const goToPayment = () => {
        if (!orderStore.order.lines.length)
            return;

        if (skipRecommendations) {
            navigate("/order");
            return;
        }

        if (menuStore.navigation.isAddedToOrder)
            navigate("/recommendations?toOrder=true");
        else
            navigate("/order");
    }

    const goToStart = async () => {
        await orderStore.cancelOrder();
        navigate("/");
    }

    if (orderStore.order.lines.length === 0 && !showBack)
        return null;

    return <>
        <div className="FooterSpace" />
        <div className="Footer">
            <div className="buttons">
                {showBack
                    ? <div className="button back" onClick={goBack}>{t("back")}</div>
                    : <div className="button startOver noBorder" onClick={goToStart}>{t("startOver")}</div>
                }
                <div className={`button payment ${showDarkViewOrder ? "dark" : ""} ${orderStore.order.lines.length === 0 ? "disable" : ""}`} onClick={goToPayment}>
                    <div className="content">
                        {orderStore.order.lines.length > 0
                            ? <div className="count">
                                <div className="text">
                                    {orderStore.order.lines.length}
                                </div>
                            </div>
                            : <div/>
                        }
                        {t("viewOrder")}
                        <div className="price">
                            {orderStore.order.total > 0
                                ? `${orderStore.order.total.toFixed(2)} ${getCurrency()}`
                                : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default observer(Footer);
